export namespace PermitListActions {
    export class GetAllCompleted {
        public static readonly type = "[PermitList] GetAllCompleted";
        constructor(public skip: number = 0, public take: number = 50) {}
    }

    export class GetAllOngoing {
        public static readonly type = "[PermitList] GetAllOngoing";
    }

    export class UpdateFilter {
        public static readonly type = "[PermitList] UpdateFilter";
        constructor(public value: string[]) {}
    }

    export class GetAllPlanned {
        public static readonly type = "[PermitList] GetAllPlanned";
    }

    export class GetAllPrepared {
        public static readonly type = "[PermitList] GetAllPrepared";
    }

    export class GetRetrievableFlammableAtexPermits {
        public static readonly type = "[PermitList] GetRetrievableFlammableAtexPermits";
        constructor(public permitId: number) {}
    }

    export class ClaimPreparedPermit {
        public static readonly type = "[PermitList] ClaimPreparedPermit";
        constructor(public permitId: number) {}
    }

    export class ConnectStandaloneFlammableAtexPermit {
        public static readonly type = "[PermitList] ConnectStandaloneFlammableAtexPermit";
        constructor(public hotWorkPermitId: number, public flammableAtexPermitId: number) {}
    }

    export class RemovePlannedPermit {
        public static readonly type = "[PermitList] RemovePlannedPermit";
        constructor(public permitId: number) {}
    }

    export class ToggleShowAllPermits {
        public static readonly type = "[PermitList] ToggleShowAllPermits";
    }
}
